// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radioButtonsLabel__Hsd12 {
  color: var(--title-inputs-sections-title);
  margin-bottom: 5px;
  display: block;
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
  text-transform: uppercase;
}
.radioButtonsLabel__Hsd12::after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.twoParts__A2H0B {
  display: grid;
  align-items: flex-start;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
}

.personalInfoStep__zWTI7 {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: 10px 32px;
}

.facilitiesSwitchWrapper__PiJIx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.facilitiesSwitch__ACWJK {
  width: 100%;
  max-width: 320px;
}

.fieldLabel__wE385 {
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  display: block;
  margin-bottom: 8px;
  padding-right: 17px;
}

.required__ZGGJb::after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.facilitiesSwitchSubtext__K06Ft {
  font-size: 8px;
  font-weight: 400;
  color: var(--tables-secondary-row-sub-title-text);
  max-width: 300px;
}

.permissionsStep__iyA5U {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.metricsBlock__qcgcB {
  display: grid;
  grid-template-columns: 210px 1fr 1fr;
  column-gap: 24px;
}
@media (max-width: 850px) {
  .metricsBlock__qcgcB {
    grid-template-columns: 150px 1fr 1fr;
    column-gap: 15px;
  }
}

.metricsBlockCustom__V86Wn {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 24px;
}

.itemBtn__B_J4N {
  margin: 0;
  display: none;
}

.userRoleBlock__t8MaZ {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 10px;
}

.roleItem__PluRH {
  height: 115px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 15px 15px 17px;
  border-radius: 2px;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-secondary-row-sub-title-surface);
  cursor: pointer;
  border-radius: 5px;
}

.activeRoleItem__XArdG {
  border-color: var(--buttons-surface);
}

.disabledRoleItem__Bobro {
  opacity: 0.7;
  pointer-events: none;
}

.roleItemName__I8PnC {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-search-text-filled);
  margin: 0;
  text-transform: capitalize;
}

.activeRoleItemName__x0jHC {
  font-weight: 500;
}

.roleItemDescription__Mq_MM {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: left;
  text-transform: lowercase;
}

.switchBlock__hYf_m {
  margin-top: 35px;
}
@media (max-width: 950px) {
  .switchBlock__hYf_m {
    margin-top: 20px;
  }
}

.notificationsStep__JGrVG {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: 500px;
  overflow-y: auto;
  padding: 1px;
}
.notificationsStep__JGrVG::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.notificationsStep__JGrVG::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.notificationsStep__JGrVG::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.notificationsStep__JGrVG::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 850px) {
  .notificationsStep__JGrVG {
    height: 375px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/UserModal/components/Steps/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAzEF;AA2EE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AAzEJ;;AA6EA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA1EF;;AA6EA;EACE,WAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA1EF;;AA6EA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,cAAA;EACA,gBAAA;EACA,iDAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,oCAAA;EACA,gBAAA;AA1EF;AA4EE;EALF;IAMI,oCAAA;IACA,gBAAA;EAzEF;AACF;;AA2EA;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;AAxEF;;AA2EA;EACE,SAAA;EACA,aAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kDAAA;EACA,yDAAA;EACA,eAAA;EACA,kBAAA;AAxEF;;AA2EA;EACE,oCAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,oBAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;EACA,SAAA;EACA,0BAAA;AAxEF;;AA2EA;EACE,gBAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,gBAAA;EACA,yBAAA;AAxEF;;AA2EA;EACE,gBAAA;AAxEF;AA0EE;EAHF;IAII,gBAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAvEF;AA1IE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA4IJ;AAzIE;EACE,+BAAA;EACA,kBAAA;AA2IJ;AAxIE;EACE,8BAAA;EACA,kBAAA;AA0IJ;AAvIE;EACE,gBAAA;EACA,kBAAA;AAyIJ;AA0DE;EAVF;IAWI,aAAA;EAvDF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.radioButtonsLabel {\n  color: var(--title-inputs-sections-title);\n  margin-bottom: 5px;\n  display: block;\n  font-size: 10px;\n  line-height: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n\n  &::after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-text-helper);\n    margin-left: 4px;\n  }\n}\n\n.twoParts {\n  display: grid;\n  align-items: flex-start;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 20px;\n}\n\n.personalInfoStep {\n  display: grid;\n  align-items: center;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 32px;\n}\n\n.facilitiesSwitchWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.facilitiesSwitch {\n  width: 100%;\n  max-width: 320px;\n}\n\n.fieldLabel {\n  font-size: 10px;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--tables-title-text);\n  display: block;\n  margin-bottom: 8px;\n  padding-right: 17px;\n}\n\n.required::after {\n  content: '*';\n  font-size: 10px;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-left: 4px;\n}\n\n.facilitiesSwitchSubtext {\n  font-size: 8px;\n  font-weight: 400;\n  color: var(--tables-secondary-row-sub-title-text);\n  max-width: 300px;\n}\n\n.permissionsStep {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.metricsBlock {\n  display: grid;\n  grid-template-columns: 210px 1fr 1fr;\n  column-gap: 24px;\n\n  @media (max-width: 850px) {\n    grid-template-columns: 150px 1fr 1fr;\n    column-gap: 15px;\n  }\n}\n.metricsBlockCustom {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 24px;\n}\n\n.itemBtn {\n  margin: 0;\n  display: none;\n}\n\n.userRoleBlock {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  column-gap: 10px;\n}\n\n.roleItem {\n  height: 115px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 15px 15px 17px;\n  border-radius: 2px;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-secondary-row-sub-title-surface);\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.activeRoleItem {\n  border-color: var(--buttons-surface);\n}\n\n.disabledRoleItem {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.roleItemName {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-search-text-filled);\n  margin: 0;\n  text-transform: capitalize;\n}\n\n.activeRoleItemName {\n  font-weight: 500;\n}\n\n.roleItemDescription {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: left;\n  text-transform: lowercase;\n}\n\n.switchBlock {\n  margin-top: 35px;\n\n  @media (max-width: 950px) {\n    margin-top: 20px;\n  }\n}\n\n.notificationsStep {\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  height: 500px;\n  overflow-y: auto;\n  padding: 1px;\n\n  @include scrollBar;\n\n  @media (max-width: 850px) {\n    height: 375px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioButtonsLabel": `radioButtonsLabel__Hsd12`,
	"twoParts": `twoParts__A2H0B`,
	"personalInfoStep": `personalInfoStep__zWTI7`,
	"facilitiesSwitchWrapper": `facilitiesSwitchWrapper__PiJIx`,
	"facilitiesSwitch": `facilitiesSwitch__ACWJK`,
	"fieldLabel": `fieldLabel__wE385`,
	"required": `required__ZGGJb`,
	"facilitiesSwitchSubtext": `facilitiesSwitchSubtext__K06Ft`,
	"permissionsStep": `permissionsStep__iyA5U`,
	"metricsBlock": `metricsBlock__qcgcB`,
	"metricsBlockCustom": `metricsBlockCustom__V86Wn`,
	"itemBtn": `itemBtn__B_J4N`,
	"userRoleBlock": `userRoleBlock__t8MaZ`,
	"roleItem": `roleItem__PluRH`,
	"activeRoleItem": `activeRoleItem__XArdG`,
	"disabledRoleItem": `disabledRoleItem__Bobro`,
	"roleItemName": `roleItemName__I8PnC`,
	"activeRoleItemName": `activeRoleItemName__x0jHC`,
	"roleItemDescription": `roleItemDescription__Mq_MM`,
	"switchBlock": `switchBlock__hYf_m`,
	"notificationsStep": `notificationsStep__JGrVG`
};
module.exports = ___CSS_LOADER_EXPORT___;
